{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Live chat campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "CARD": {
        "STATUS": {
          "ENABLED": "فعال شد",
          "DISABLED": "غیرفعال شد"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "ارسال شده توسط",
          "BOT": "ربات",
          "FROM": "از",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No live chat campaigns are available",
        "SUBTITLE": "Connect with your customers using proactive messages.  Click 'Create campaign' to get started."
      },
      "CREATE": {
        "TITLE": "Create a live chat campaign",
        "CANCEL_BUTTON_TEXT": "انصراف",
        "CREATE_BUTTON_TEXT": "ايجاد كردن",
        "FORM": {
          "TITLE": {
            "LABEL": "عنوان",
            "PLACEHOLDER": "لطفا عنوان کمپین را وارد کنید",
            "ERROR": "عنوان الزامی است"
          },
          "MESSAGE": {
            "LABEL": "پیام",
            "PLACEHOLDER": "لطفاً پیام کمپین را وارد کنید",
            "ERROR": "پیام الزامی است"
          },
          "INBOX": {
            "LABEL": "انتخاب صندوق ورودی",
            "PLACEHOLDER": "انتخاب صندوق ورودی",
            "ERROR": "صندوق ورودی مورد نیاز است"
          },
          "SENT_BY": {
            "LABEL": "ارسال شده توسط",
            "PLACEHOLDER": "Please select sender",
            "ERROR": "ارسال کننده الزامی است"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "لطفاً URL را وارد کنید",
            "ERROR": "لطفا آدرس URL صحیحی وارد کنید"
          },
          "TIME_ON_PAGE": {
            "LABEL": "زمان در صفحه (ثانیه ها)",
            "PLACEHOLDER": "لطفاً زمان را وارد کنید",
            "ERROR": "زمان حضور در صفحه لازم است"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Other preferences",
            "ENABLED": "فعال کردن کمپین",
            "TRIGGER_ONLY_BUSINESS_HOURS": "تنها در طول ساعات کاری"
          },
          "BUTTONS": {
            "CREATE": "ايجاد كردن",
            "CANCEL": "انصراف"
          },
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign created successfully",
            "ERROR_MESSAGE": "یک خطای وجود دارد. لطفا دوباره تلاش کنید."
          }
        }
      },
      "EDIT": {
        "TITLE": "Edit live chat campaign",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign updated successfully",
            "ERROR_MESSAGE": "یک خطای وجود دارد. لطفا دوباره تلاش کنید."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No SMS campaigns are available",
        "SUBTITLE": "Launch an SMS campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "PROCESSING": "Processing",
          "COMPLETED": "تکمیل شد",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create SMS campaign",
        "CANCEL_BUTTON_TEXT": "انصراف",
        "CREATE_BUTTON_TEXT": "ايجاد كردن",
        "FORM": {
          "TITLE": {
            "LABEL": "عنوان",
            "PLACEHOLDER": "لطفا عنوان کمپین را وارد کنید",
            "ERROR": "عنوان الزامی است"
          },
          "MESSAGE": {
            "LABEL": "پیام",
            "PLACEHOLDER": "لطفاً پیام کمپین را وارد کنید",
            "ERROR": "پیام الزامی است"
          },
          "INBOX": {
            "LABEL": "انتخاب صندوق ورودی",
            "PLACEHOLDER": "انتخاب صندوق ورودی",
            "ERROR": "صندوق ورودی مورد نیاز است"
          },
          "AUDIENCE": {
            "LABEL": "شنودگان",
            "PLACEHOLDER": "برچسب های مشتری را انتخاب کنید",
            "ERROR": "شنودگان ضروری است"
          },
          "SCHEDULED_AT": {
            "LABEL": "زمان برنامه ریزی شده",
            "PLACEHOLDER": "لطفاً زمان را انتخاب کنید",
            "ERROR": "زمان برنامه ریزی شده الزامی است"
          },
          "BUTTONS": {
            "CREATE": "ايجاد كردن",
            "CANCEL": "انصراف"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS campaign created successfully",
            "ERROR_MESSAGE": "یک خطای وجود دارد. لطفا دوباره تلاش کنید."
          }
        }
      }
    },
    "WHATSAPP": {
      "HEADER_TITLE": "WhatsApp campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No WhatsApp campaigns are available",
        "SUBTITLE": "Launch a WhatsApp campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "PROCESSING": "Processing",
          "COMPLETED": "تکمیل شد",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create WhatsApp campaign",
        "CANCEL_BUTTON_TEXT": "انصراف",
        "CREATE_BUTTON_TEXT": "ايجاد كردن",
        "FORM": {
          "TITLE": {
            "LABEL": "عنوان",
            "PLACEHOLDER": "لطفا عنوان کمپین را وارد کنید",
            "ERROR": "عنوان الزامی است"
          },
          "INBOX": {
            "LABEL": "انتخاب صندوق ورودی",
            "PLACEHOLDER": "انتخاب صندوق ورودی",
            "ERROR": "صندوق ورودی مورد نیاز است"
          },
          "TEMPLATE": {
            "LABEL": "WhatsApp Template",
            "PLACEHOLDER": "Select a template",
            "INFO": "Select a template to use for this campaign.",
            "ERROR": "Template is required",
            "PREVIEW_TITLE": "فرآیند {templateName}",
            "LANGUAGE": "زبان",
            "CATEGORY": "دسته‌بندی",
            "VARIABLES_LABEL": "متغیرها",
            "VARIABLE_PLACEHOLDER": "Enter value for {variable}"
          },
          "AUDIENCE": {
            "LABEL": "شنودگان",
            "PLACEHOLDER": "برچسب های مشتری را انتخاب کنید",
            "ERROR": "شنودگان ضروری است"
          },
          "SCHEDULED_AT": {
            "LABEL": "زمان برنامه ریزی شده",
            "PLACEHOLDER": "لطفاً زمان را انتخاب کنید",
            "ERROR": "زمان برنامه ریزی شده الزامی است"
          },
          "BUTTONS": {
            "CREATE": "ايجاد كردن",
            "CANCEL": "انصراف"
          },
          "API": {
            "SUCCESS_MESSAGE": "WhatsApp campaign created successfully",
            "ERROR_MESSAGE": "یک خطای وجود دارد. لطفا دوباره تلاش کنید."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "مطمئن هستید که حذف شود?",
      "DESCRIPTION": "The delete action is permanent and cannot be reversed.",
      "CONFIRM": "حذف",
      "API": {
        "SUCCESS_MESSAGE": "کمپین با موفقیت حذف شد",
        "ERROR_MESSAGE": "یک خطای وجود دارد. لطفا دوباره تلاش کنید."
      }
    }
  }
}
